import { combineReducers } from "@reduxjs/toolkit";
import filterSlice from "./filterSlice";

export const layoutReducer = combineReducers({
  filterSlice,
});

export default layoutReducer;
